export const couriers = {
    'DPD': {
        displayName: 'DPD',
        icon: 'van',
    },
    'UPS': {
        displayName: 'UPS',
        icon: 'van',
    },
    'UKMail': {
        displayName: 'DPD', // currently all UKMail deliveries are handelled by DPD for FF
        icon: 'van',
    },
    'Global': {
        displayName: 'a Freddie’s van',
        icon: 'van',
    },
    'FF Vans': {
        displayName: 'a Freddie’s van',
        icon: 'van',
    },
    'Zedify': {
        displayName: 'a Freddie’s electric bike',
        icon: 'bike',
    },
    'Pedal Me': {
        displayName: 'a Freddie’s electric bike',
        icon: 'bike',
    },
    'FF Bikes': {
        displayName: 'a Freddie’s electric bike',
        icon: 'bike',
    },
};
